import React from "react";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps {
  text?: string;
  size?: number; // in pixels
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text = "Loading...",
  size = 50,
  color = "#f97316", // Tailwind orange-500
}) => {
  return (
    <div className="loading-wrapper">
      <div
        className="spinner"
        style={{ width: size, height: size, borderTopColor: color }}
      ></div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
